(function($) {
    $.fn.validateNumber = function(digits, decimals, allowNegative) {
        this.unbind("keypress.validateNumber");
        this.bind("keypress.validateNumber", function(e) {
            if (_validateNumber(e, digits, decimals, allowNegative) === false) {
                e.preventDefault();
            }
        });

        function _validateNumber(e, digits, decimals, allowNegative) {
            var selStart = e.target.selectionStart,
                selEnd = e.target.selectionEnd;
            var value = $(e.target).val();
            var charCode = (e.char !== undefined ? e.char : String.fromCharCode(e.which));

            if (allowNegative && value === '' && charCode === '-') {
                return true;
            }

            var negative = "";
            if (allowNegative) {
                negative = "[\-]{0,1}";
            }

            if (decimals > 0) {
                var pattern = "^" + negative + "\\d{1," + digits + "}(?:\\.\\d{0," + decimals + "})?$";
            } else {
                var pattern = "^" + negative + "\\d{1," + digits + "}$";
            }
            var allowed = [0,8]; // povolené znaky
            var replace = false;

            // nahrazovani povolenych znaku
            switch(charCode) {
                case ",": charCode = "."; replace = true; break;
            }

            var splittedValue = value.split("");
            splittedValue.splice(selEnd, 0, charCode);
            for(var key in splittedValue) {
                if (selStart == selEnd) {
                } else {
                    if (selStart <= key && key < selEnd) {
                        delete splittedValue[key];
                    }
                }
            }
            var newValue = splittedValue.join("");

            var re = new RegExp(pattern);

            if (allowed.join().indexOf(e.which) != -1) { // zadavany znak je v povolenych znacich
                return true;
            }

            var ret = re.test(newValue);

            if (ret && replace) { // bylo nahrazovano a vstup je validni
                $(e.target).val(newValue);
                return false;
            }

            return ret;
        }

        return this;
    };

    $.fn.validatePSC = function() {
        return this.each(function() {
            const $input = $(this);

            // Funkce pro formátování PSČ
            function formatPSC() {
                let value = $input.val().replace(/\s+/g, '');

                // Povolíme jen číslice
                value = value.replace(/[^\d]/g, '');

                // Omezíme na max 5 číslic
                if (value.length > 5) {
                    value = value.substring(0, 5);
                }

                // Formátování s mezerou po 3. znaku
                if (value.length > 3) {
                    value = value.substring(0, 3) + ' ' + value.substring(3);
                }

                $input.val(value);
            }

            // Odstraníme existující události, aby se nepřidávaly opakovaně
            $input.off('input.psc blur.psc');

            // Přidáme události
            $input.on('input.psc', formatPSC);
            $input.on('blur.psc', formatPSC);

            // Formátujeme i při inicializaci
            formatPSC();
        });
    };
})(jQuery);
